export enum CardStatus {
  TO_ACTIVATE = 'TO_ACTIVATE',
  ACTIVATED = 'ACTIVATED',
  SUSPENDED = 'SUSPENDED',
  CANCELED = 'CANCELED',
  TO_ORDER = 'TO_ORDER',
}
